/**
 * Response shape from POST auth/mfa/enable for authenticator app (QR + recovery codes).
 */
export type Authenticator = {
  qr_png_base64?: string
  recovery_codes?: string[]
  message?: string
}

/**
 * MFA factor type: only one can be enabled at a time.
 */
export enum MFA_FACTOR_TYPE {
  APP,
  EMAIL,
  PHONE
}
